import moment from 'moment'

export function preparePaymentOptionPayload(applicationId, selectedOptionId, option) {
  const payload = {
    application_id: applicationId,
    condition_id: selectedOptionId,
    condition_type: 'PaymentOption',
    count_of_payments: option.amountOfPayments,
    payment_method: option.selectedMethod,
    start_date: null,
  }

  if (option.schedule_option?.allowCustomSchedule && option.customSchedule?.length) {
    payload.custom_schedule = option.customSchedule.map(r => ({
      date: r.date,
      amount: parseFloat(r.amount),
    }))
    payload.count_of_payments = option.customSchedule.length
  } else if (moment(option.startDate, 'MM/DD/YYYY', true).isValid()) {
    payload.start_date = moment(option.startDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
  }

  return payload
}
